module.exports = __webpack_public_path__ + "img/troy_immolation.d072500f.png";